import React from "react";
import Image from "next/image";
import { Heading, Stack } from "@chakra-ui/react";
import { useSectionHeadingVariant } from "@/theme/components/useSectionHeading";
import ArchitectureImg from "public/openStack/architecture.png";

const Architecture = () => {
  const HeadingVariant = useSectionHeadingVariant();
  return (
    <Stack justify={"center"} align={"center"} spacing={8}>
      <Heading as="h1" variant={HeadingVariant} mb={4}>
        Managed Open Stack Architecture
      </Heading>
      <Image
        src={ArchitectureImg}
        alt="OneMind Infographic"
        style={{ height: "auto", maxWidth: "1000px", width: "100%" }}
      />
    </Stack>
  );
};

export default Architecture;
